/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import DashboardNews from './DashboardNews'
import { DashboardSummmary } from './DashboardSummary'
import { BreadcumbsSection } from '../../components/BreadcumbsSection'
import { IsMayoristaRole } from '../../helpers/utils'
import { useAuth } from '../../modules/auth'
import { ModalInfo } from '../../components/ModalInfo'
import { useModalControl } from '../../helpers/useModalControl'

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const { auth } = useAuth()
  const [showModalInfo, setShowModalInfo] = useModalControl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <ModalInfo show={showModalInfo} onHide={() => {
        setShowModalInfo(false)
      }}/>
      <BreadcumbsSection title={intl.formatMessage({ id: 'DASHBOARD.TITLE' })} />
      <DashboardNews />
      {IsMayoristaRole(auth) && <DashboardSummmary />}
    </>
  )
}

export { DashboardWrapper }
